<template>
    <div>
        <q-score-card key="QScoreCardTotalRecruits" ref="card" title="Total Agents" api-endpoint="total_recruits" drill-down-label="Agent Breakdown" drill-down-route="Drilldown_TotalRecruits" card-style="recruiting" :agent-code="agentCode" :filters="filters" v-on:most_current="updateMostCurrent">
            Note: This stat may include inactive/terminated agents. Only agents with an NPN number are included - does not include active unlicensed agents.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardTotalRecruits",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {
        updateMostCurrent: function(most_current) {
            this.$emit('most_current', most_current);
        }
    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
